var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('label',[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('p',{attrs:{"id":_vm.idPgh}},[_vm._v(_vm._s(_vm.content))]),_c('div',{staticClass:"extra-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }